document.addEventListener('turbolinks:load', () => {
    const container = document.getElementById('policy-container');
    if (!container) return;

    const template = document.getElementById('cancel-policy-template');
    const addButton = document.getElementById('add-policy');
    let policyCount = container.querySelectorAll('.cancel-policy-row').length;

    function validatePolicies() {
        const rows = container.querySelectorAll('.cancel-policy-row');
        const policies = Array.from(rows).map(row => ({
            days_before: row.querySelector('[name*="[days_before]"]').value,
            penalty_percentage: row.querySelector('[name*="[penalty_percentage]"]').value,
            element: row
        }));

        // エラーメッセージをクリア
        for (const el of document.querySelectorAll('.cancel-policy-error')) {
            el.remove();
        }

        let isValid = true;

        // 空値チェック
        const emptyPolicies = policies.some(policy => !policy.days_before || !policy.penalty_percentage);
        if (emptyPolicies) {
            showError('空の値があります。入力をしてください。');
            isValid = false;
        }

        // 数値に変換（空値チェック後に実行）
        const validPolicies = policies.filter(p => p.days_before && p.penalty_percentage).map(p => ({
            ...p,
            days_before: Number.parseInt(p.days_before),
            penalty_percentage: Number.parseInt(p.penalty_percentage)
        }));

        // 当日（0日前）の設定が必要
        const hasSameDayPolicy = validPolicies.some(p => p.days_before === 0);
        if (!hasSameDayPolicy) {
            showError('当日のキャンセルポリシーは必ず設定してください');
            isValid = false;
        }

        // 重複チェック
        const daysBefore = validPolicies.map(p => p.days_before);
        if (new Set(daysBefore).size !== daysBefore.length) {
            showError('同じ日数を複数設定することはできません');
            isValid = false;
        }

        const penalties = validPolicies.map(p => p.penalty_percentage);
        if (new Set(penalties).size !== penalties.length) {
            showError('同じキャンセル料率を複数設定することはできません');
            isValid = false;
        }

        // 日数が大きくなるほどキャンセル料が小さくなることを確認
        for (let i = 0; i < validPolicies.length; i++) {
            for (let j = 0; j < validPolicies.length; j++) {
                if (validPolicies[i].days_before > validPolicies[j].days_before &&
                    validPolicies[i].penalty_percentage >= validPolicies[j].penalty_percentage) {
                    showError(
                        `${validPolicies[i].days_before}日前のキャンセル料は${validPolicies[j].days_before}日前のキャンセル料より小さい値を設定してください`
                    );
                    isValid = false;
                }
            }
        }

        return isValid;
    }

    function showError(message, element = null) {
        const errorDiv = document.createElement('div');
        errorDiv.className = 'cancel-policy-error text-red-500 text-sm mt-1';
        errorDiv.textContent = message;

        // エラーメッセージは常にフォームの上部に表示
        const cancelPoliciesDiv = document.getElementById('cancel-policies');
        cancelPoliciesDiv.insertBefore(errorDiv, cancelPoliciesDiv.firstChild);
    }

    // フォーム送信前のバリデーション
    const form = container.closest('form');
    form.addEventListener('submit', e => {
        if (e.defaultPrevented) return; // 他のハンドラーで既に preventDefault された場合は処理しない

        if (!validatePolicies()) {
            e.preventDefault();
            e.stopPropagation();
            alert('キャンセルポリシーの設定に誤りがあります。エラーメッセージを確認してください。');
            // エラーのある部分までスクロール
            const cancelPoliciesDiv = document.getElementById('cancel-policies');
            cancelPoliciesDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });

            // disable-with の状態をリセット
            const submitButton = form.querySelector('button[type="submit"]');
            if (submitButton) {
                submitButton.disabled = false;
                submitButton.textContent = submitButton.dataset.originalText || '保存';
            }
            return false;
        }
    }, true); // キャプチャフェーズで実行

    // 値変更時のバリデーション
    container.addEventListener('change', e => {
        if (e.target.matches('select, input')) {
            validatePolicies();
        }
    });

    addButton.addEventListener('click', () => {
        if (policyCount >= 10) {
            alert('キャンセルポリシーは最大10個までです');
            return;
        }
        const newRow = template.content.cloneNode(true);
        for (const input of newRow.querySelectorAll('[name*="INDEX"]')) {
            input.name = input.name.replace('INDEX', policyCount);
            if (input.tagName === 'SELECT') {
                input.value = '';
                input.selectedIndex = -1;
            } else if (input.tagName === 'INPUT') {
                input.value = '';
            }
        }
        container.appendChild(newRow);
        policyCount++;
        validatePolicies();
    });

    container.addEventListener('click', e => {
        if (e.target.classList.contains('remove-policy')) {
            if (policyCount <= 1) {
                alert('最低1つのキャンセルポリシーが必要です');
                return;
            }
            e.target.closest('.cancel-policy-row').remove();
            policyCount--;
            validatePolicies();
        }
    });

    // 初期表示時のバリデーション
    validatePolicies();
});